/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 11:33:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorTabbar/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { request_tabBar } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorTabbar/slice';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';

const CloneBtn = (props) => {
  const params: any = useParams();
  const { contentUuid } = params;
  const _d = useDispatch();
  const handleOnClick = () => {
    _d(
      request_tabBar({
        //1===true 0===false
        uuid: contentUuid,
        params: {
          [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
        },
        isClone: true,
      }),
    );
  };
  return <Button onClick={handleOnClick} disabled={props?.disabled} />;
};
export default CloneBtn;
